<template>
  <form-checkbox
    :id="id"
    :indeterminate="indeterminate"
    :checked="checked"
    :label="label"
    :disabled="disabled"
    :is-update-in-process="planetStore.isUpdateInProcess"
    :ignore-update-in-process="ignoreUpdateInProcess"
    :classes="classes"
    :data-qa="dataQa"
    :tabindex="tabindex"
    @update:checked-value="emit('update:checkedValue', $event)"
  >
  </form-checkbox>
</template>

<script setup lang="ts">
import { usePlanetStore } from '@/store/PlanetStore';
import FormCheckbox from 'ui-component-library/rbz/components/FormCheckbox.vue';

interface RbzFormCheckboxProps {
  id: string;
  indeterminate?: boolean;
  checked?: boolean;
  label?: string;
  disabled?: boolean;
  ignoreUpdateInProcess?: boolean;
  classes?: string;
  dataQa?: string;
  tabindex?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<RbzFormCheckboxProps>(), {
  checked: false,
  indeterminate: false,
  label: '',
  disabled: false,
  classes: '',
  dataQa: '',
});

interface RbzFormCheckboxEmits {
  (e: 'update:checkedValue', value: boolean): void;
}

const emit = defineEmits<RbzFormCheckboxEmits>();

const planetStore = usePlanetStore();
</script>
